<div class="clearfix">
  <div class="col-12 md:col-12"><h3>{{'Mg_Right_Cust' | translate}}</h3></div>
  <div class="col-12 md:col-12">
    <p-tabView
      [controlClose]="true"
      (onChange)="handleChange($event)"
      (onClose)="closeTab($event)"
      [activeIndex]="index"
      >
      <p-tabPanel [header]="'List' | translate" [selected]="0 == index" [headerStyle]="{ 'font-weight': 'bold' }">
        <div class="table-tools">
          <button
            (click)="add($event)"
            class="p-button p-component p-button-text-only btn-square"
            >
            {{'Add_Screen' | translate}}
          </button>
        </div>
        <br class="col-12 md:col-12" />
        <p-table
          #dt
          [selectionMode]="'single'"
          [columns]="listColumns"
          [value]="results"
          [rows]="100"
          [paginator]="true"
          responsiveLayout="stack"
          [breakpoint]="'960px'"
          (onRowSelect)="showDetails($event)"
          (onFilter)="setFilteredList($event)"
          [sortField]="'name'"
          >
          <ng-template pTemplate="caption">
            <span class="header-grid-wrapper">
              <span class="align-right">{{'Tot' | translate}} {{ results.length }}  {{'Screen_N' | translate}}</span>
            </span>
          </ng-template>
          <ng-template let-columns pTemplate="header">
            <tr>
              <th [pSortableColumn]="columns[0].field" class="width-auto">
                <p-sortIcon [field]="columns[0].field"></p-sortIcon>{{ columns[0].header }}
                <input
                  (click)="$event.stopPropagation()"
                  pInputText
                  type="text"
                  (input)="dt.filter($event.target.value, columns[0].field, 'contains')"
                  style="color: darkgrey"
                />
              </th>
              <th [pSortableColumn]="columns[1].field" class="width-auto">
                <p-sortIcon [field]="columns[1].field"></p-sortIcon>{{ columns[1].header }}
                <input
                  (click)="$event.stopPropagation()"
                  pInputText
                  type="text"
                  (input)="dt.filter($event.target.value, columns[1].field, 'contains')"
                  style="color: darkgrey"
                />
              </th>
              <th class="width-auto">
                {{ columns[2].header }}
                <p-dropdown
                  [options]="visibilityList"
                  [style]="{ width: '100%' }"
                  (onChange)="dt.filter($event.value, columns[2].field, 'equals')"
                ></p-dropdown>
              </th>
              <th class="width-auto">
                {{ columns[3].header }}
              </th>
            </tr>
          </ng-template>
              <ng-template let-rowData let-columns="columns" pTemplate="body">
                <tr [pSelectableRow]="rowData">
                  <td class="width-auto">
                    {{ rowData[columns[0].field] }}
                  </td>
                  <td class="width-auto">
                    {{ rowData[columns[1].field] }}
                  </td>
                  <td class="width-auto">
                    <visibility [value]="rowData[columns[2].field]"></visibility>
                  </td>
                  <td class="width-auto">
                    @if (rowData[columns[3].field] === 1) {
                      <i class="pi pi-check iconstyle"></i>
                    }
                  </td>
                </tr>
              </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">{{'Empty' | translate}}</td>
            </tr>
          </ng-template>
            </p-table>
          </p-tabPanel>
          @for (item of itemsSelected; track item; let i = $index) {
            <p-tabPanel
              header="{{ item._label }}"
              [selected]="i == index - 1"
              [closable]="true"
              >
              @if (item.id === -1) {
                <app-add-custrights
                  [groupList]="groupList"
                  [userList]="userList"
                  [screenList]="screenBase"
                  (onCancel)="cancelAdd($event)"
                  (onValidate)="addTab($event)"
                  >
                </app-add-custrights>
              }
              @if (item.id !== -1) {
                <app-edit-custrights
                  [groupList]="groupList"
                  [userList]="userList"
                  [screenList]="screenList"
                  [item]="item"
                  (onCancel)="closeTab($event)"
                  (onValidate)="validateTab($event)"
                  (onDeleteItem)="confirmDelete($event)"
                  >
                </app-edit-custrights>
              }
            </p-tabPanel>
          }
        </p-tabView>
      </div>
    </div>

    <app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>
